import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./Expo.scss";
import ContentSection from "./children/contentSection";
import SidePanel from "./children/sidePanel";
import KdsService from "../../../services/KdsService";
import { formatdata, groupExpoDataByMenugroup } from "../Expo/children/helper";
import socket from "../../../services/Socket";

const Expo = (props) => {
  const wrapperRef = useRef(null);
  const [zooming, setZooming] = useState("100%");
  const [expoData, setExpoData] = useState([]);
  const [currentFilter, setCurrentFilter] = useState("");
  const [selectedMenuItemId, setSelectedMenuItemId] = useState("");
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const [kitchenData, setKitchenData] = useState([]);
  const [showCompleted, setShowCompleted] = useState(false);

  const getDataList = () => {
    const restaurant_id = props.adminRestaurant;
    KdsService.getExpoData(restaurant_id).then((res) => {
      console.log(res);
      const dataWithPriority = Object.values(res).flat();
      const groupedData = Object.values(formatdata(dataWithPriority));
      setExpoData(groupedData);
      const sidepanelItems = groupExpoDataByMenugroup(dataWithPriority);
      setSideMenuItems(sidepanelItems);
    }).catch(err => console.log(err));
  };

  const getAllKitchenData = () => {
    const restaurant_id = props.adminRestaurant;
    KdsService.getExpoData(restaurant_id).then((res) => {
      const dataWithPriority = Object.values(res).flat();
      const groupedData = Object.values(formatdata(dataWithPriority));
      setKitchenData(groupedData);
    }).catch((err) => console.log(err));
  };

  const onSendOrder = async (items) => {
    let apiData = [];
    items.map((field)=>{
      if(field.is_sent_to_kitchen){
        apiData.push({
          id: field.id,
          is_sent_to_kitchen: true
        })
      }
    })
    KdsService.updateCartItems(apiData).then(()=>{
      getDataList();
    });
  };

  const onOrderUpdate = () => {
    getDataList();
  };

  useEffect(() => {
    wrapperRef.current.style.zoom = "100%";
    socket.connect();
    function onConnect() {
      // console.log('setIsConnected', true);
    }

    function onDisconnect() {
      // console.log('setIsConnected', false)
    }

    socket.on("connect_error", (err) => {
      console.error(`connect_error due to ${err.message}`);
    });

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("ORDER_LIVE_UPDATE", onOrderUpdate);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("ORDER_LIVE_UPDATE", onOrderUpdate);
    };
  }, []);

  const handleUpdateCartItem = async (cartItemId, payload) => {
    await KdsService.updateOrderData(cartItemId, props.adminRestaurant, {
      ...payload,
    });
  };
  useEffect(() => {
    getDataList();
    getAllKitchenData();
  }, [props.adminRestaurant]);

  return (
    <div ref={wrapperRef} className="expo_page">
      <div className="left_menu">
        <SidePanel
          sideMenuItems={sideMenuItems}
          selectedMenuItemId={selectedMenuItemId}
          setSelectedMenuItemId={setSelectedMenuItemId}
        />
      </div>
      <div className="content_area">
        <ContentSection
          wrapperRef={wrapperRef}
          setZooming={setZooming}
          // expoData={expoData.concat(kitchenData)}// to fix the duplicate card in listing
          expoData={expoData}
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
          onSendOrder={onSendOrder}
          zooming={zooming}
          selectedMenuItemId={selectedMenuItemId}
          handleUpdateCartItem={handleUpdateCartItem}
          setShowCompleted={setShowCompleted}
          showCompleted={showCompleted}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Expo));
